import breadcrumbComp from "../../common/breadcrumb-comp.vue";
import encryptUtility from "../../utility/js/encrypt-utility";
import announcementService from "../js/announcement-service";
import utility from "@/shared/utility";
import AddFavourite from "../../utility/js/addFav";
import CommonDialog from "../../common/common-dialog.vue";
export default {
  data: () => ({
    searchText: "",
    userId: encryptUtility.localStorageDecrypt("userID"),
    backSlash: true,
    route: "",
    actionList: [],
    mainPage: "",
    favouriteList: [],
    announcementToDelete:"",
    pageUrl: "",
    subPage: "",
    showAdd: false,
    showDeleteDialog: false,
    deleteDialogMessage: "Are you sure you want to delete this announcement?",
    announcementHeader: [
      {
        text: "Announcement Name",
        value: "announcement_name",
        class: "primary customwhite--text",
      },
      {
        text: "Announcement Type",
        value: "announcement_type_name",
        class: "primary customwhite--text",
      },

      // {
      //   text: "Duration/Downtime (hrs)",
      //   value: "duration",
      //   class: "primary customwhite--text",
      // },
      
      {
        text: "Announcement Date",
        value: "announcement_date",
        class: "primary customwhite--text",
      },
      {
        text: "Contact Details",
        value: "contact_details",
        class: "primary customwhite--text",
      },{
        text: "Publish Date",
        value: "publish_start_datetime",
        class: "primary customwhite--text",
      },
      {
        text: "Enabled",
        value: "enabled",
        class: "primary customwhite--text",
      },
      // {
      //   text: "Created Date",
      //   value: "cdate",
      //   class: "primary customwhite--text",
      // },
      {
        text: "Created By",
        value: "username",
        class: "primary customwhite--text",
      },
      {
        text: "Action",
        value: "action",
        class: "primary customwhite--text",
      },
    ],
    announcementList: [],
  }),
  async created() {
    this.route = this.$route.path.replace("/", "");
    let data = await AddFavourite.getPageAction(this.userId, this.route);
    this.actionList = data.actionList;
    this.mainPage = data.mainPage;
    this.favouriteList = data.favouriteList;
    this.pageUrl = data.pageUrl;
    this.subPage = data.subPage;
    this.showAdd = data.showAdd;
  },
  mounted() {
    console.log(this.userId);
    this.getAnnouncementList();
  },
  computed: {},
  methods: {
    async getAnnouncementList() {
      let response = await announcementService.getAnnouncementListData(
        "get",
        this.userId,
        this.searchText
      );
      this.announcementList = response;
      this.announcementList.forEach((announcement) => {
        announcement.enabled = announcement.enabled ? "Yes" : "No";
        announcement.cdate = utility.displayDateFormat(announcement.cdate);
        announcement.announcement_date = utility.displayDateFormat(
          announcement.announcement_date
        );
        announcement.publish_start_datetime = utility.displayDateFormat(
          announcement.publish_start_datetime
        );
        announcement.contact_details = `${announcement.contact_name}${
          announcement.support_email
            ? ", " + announcement.support_email
            : ""
        }${announcement.phone ? ", " + announcement.phone : ""}`;
      });
      console.log("Announcement List ", this.announcementList);
    },
    onClickNewAnnouncement() {
      this.$router.push({ path: "/announcement-add" });
    },
    onClickViewAnnouncement(item) {
      this.$router.push({
        path: `/announcement-details/${btoa(item.announcement_id.toString())}`,
      });
    },
    addFav() {
      this.showAdd = !this.showAdd;
      AddFavourite.add_remove_Favourite(this.showAdd, this.userId, this.route);
    },
    onClickDeleteAnnouncement(item) {
      this.showDeleteDialog = true;
      this.announcementToDelete = item;
    },

    async confirmDeleteAnnouncement(){
      let resp=await announcementService.deleteAnnouncement("get",this.announcementToDelete.announcement_id,true);
      this.showDeleteDialog=false;
      console.log(resp);
      this.getAnnouncementList();

    },

      
  },

  components: {
    breadcrumbComp,
    CommonDialog,
  },
};
